import styled from 'styled-components';

export const PositionBlock = styled.div`
  margin: 1rem 0;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

export const RadioBlock = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin: 0 1rem;
`;
